import { useMemo } from 'react';
import { FeatureReadinessNameUseSchedulerV3 } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/feature_readiness.pb';
import { ScheduleOrg } from '@wetags/schedule';
import { isEmpty } from 'lodash-es';
import { DataSourcesQueries } from '@frontend/api-data-sources';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useAppScopeStore, useScopedAppFlagStore } from '@frontend/scope';
import { useAppFlagStore } from '@frontend/shared';

export const useGetWSMActiveLocationIds = () => {
  const { selectedLocationIds } = useAppScopeStore();
  const { getCustomizationFlagLocationMap } = useAppFlagStore();

  const wsmActiveLocationIds = Object.entries(
    getCustomizationFlagLocationMap({ locationIds: selectedLocationIds, flagName: 'weaveschedulemanagement' })
  )
    .filter(([, flag]) => flag?.state === 'ACTIVE')
    .map(([locationId]) => locationId);

  return { wsmActiveLocationIds };
};

export const useGetSchedulerV3FeatureFlagDetails = () => {
  const { featureFlags } = useAppFlagStore();
  const isFeatureFlagsLoaded = !isEmpty(featureFlags);
  const { selectedOrgId, selectedGroupId } = useAppScopeStore();
  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const [isFeatureReadinessProjectEnabled, isFeatureReadinessProjectWetagLoading] = ScheduleOrg.useWetag(
    'feature-readiness-project-enablement'
  );

  const { isIntegratedOffice, isLoading: isLoadingIntegrationDetails } =
    DataSourcesQueries.useGetAccessibleIntegrations();

  const { data, isLoading: isLoadingFeatureReadiness } = SchedulerV3.Queries.useListLocationGroupFeatureReadinessQuery({
    request: {
      orgId: selectedOrgId,
      parentLocationId: selectedGroupId,
      names: [FeatureReadinessNameUseSchedulerV3],
    },
    options: {
      enabled: !isFeatureReadinessProjectWetagLoading && isFeatureReadinessProjectEnabled,
    },
  });

  const isV3Enabled = useMemo(() => {
    const hasSchedulerV3UI = getFeatureFlagValue('scheduler-v3-ui', 'ALL');
    const oldScheduleV3FF = hasSchedulerV3UI || !isIntegratedOffice;
    const newScheduleV3FF =
      data?.features?.find((feature) => feature.name === FeatureReadinessNameUseSchedulerV3)?.enabled ?? false;

    return isFeatureReadinessProjectEnabled ? newScheduleV3FF : oldScheduleV3FF;
  }, [data?.features, getFeatureFlagValue, isFeatureReadinessProjectEnabled, isIntegratedOffice]);

  const isLoading =
    isLoadingIntegrationDetails ||
    !isFeatureFlagsLoaded ||
    isFeatureReadinessProjectWetagLoading ||
    isLoadingFeatureReadiness;

  return {
    isScheduleV3FlagEnabled: isLoading ? false : isV3Enabled,
    isSchedulerV2FlagEnabled: isLoading ? false : !isV3Enabled,
    isLoading,
  };
};
